import styles from './browser-bar.module.scss';
import { MobileBrowserBackArrow, MobileBrowserMenu } from '@app/dashboard/assets/icons';

export interface BrowserBarProps {
    url: string;
    isMobile?: boolean;
}

export const BrowserBar = ({ url, isMobile = false }: BrowserBarProps) => {
    return (
        <div
            className={`${styles['browser-bar']} ${isMobile ? styles['browser-bar--mobile'] : ''
                }`}
        >
            {isMobile ? (
                // Mobile browser style
                <>
                    <div className={styles['browser-bar__mobile-back']}>
                        {MobileBrowserBackArrow}
                    </div>
                    <div className={styles['browser-bar__mobile-url']}>{url}</div>
                    <div className={styles['browser-bar__mobile-menu']}>
                        {MobileBrowserMenu}
                    </div>
                </>
            ) : (
                // Desktop browser style
                <>
                    <div className={styles['browser-bar__controls']}>
                        <div className={styles['browser-bar__dot']} />
                        <div className={styles['browser-bar__dot']} />
                        <div className={styles['browser-bar__dot']} />
                    </div>
                    <div className={styles['browser-bar__url']}>{url}</div>
                    <div className={styles['browser-bar__spacer']} />
                </>
            )}
        </div>
    );
};

